import React from 'react';
import { Button } from 'govuk-react-jsx';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCompanyData,
  setAnswers,
} from '../../features/registration/registrationJourneySlice';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import { checkAnswers, updateAccount } from '../../firebase';
import useTitle from '../../hooks/useTitle';

const ConfirmBusinessDetails = () => {
  const companyDataRedux = useSelector(getCompanyData);
  const history = useHistory();
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  const dispatch = useDispatch();
  useTitle(
    'landlordReg.ConfirmBusinessDetails.s8',
    'Confirm company details - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );

  const redirectCheckAnswers = () => {
    checkAnswers()
      .then((response) => {
        const { data } = response;

        dispatch(setAnswers(data));

        history.push('/landlordReg/check-your-answers');
      })
      .catch(() => {
        // TODO: Show error message
      });
  };

  const handleBtnClick = () => {
    updateAccount(companyDataRedux)
      .then(() => {
        redirectCheckAnswers();
      })
      .catch(() => {
        // TODO: Show an error message
      });
  };

  const pageModel = (
    <>
      <div className="govuk-form-group">
        <h1 className="govuk-label--xl govuk-!-padding-bottom-7">
          {copyProvider.getCopy(
            'landlordReg.ConfirmBusinessDetails.s1',
            'Confirm the company details'
          )}
        </h1>
        <table className="govuk-body" role="presentation">
          <tr>
            <td>
              <h3 className="govuk-!-margin-top-0">
                {copyProvider.getCopy(
                  'landlordReg.ConfirmBusinessDetails.s2',
                  'Company registration number'
                )}
              </h3>
              <p className="govuk-body govuk-!-font-size-19">
                {companyDataRedux && companyDataRedux.companyRegNumber}
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <h3 className="govuk-!-margin-top-0">
                {copyProvider.getCopy(
                  'landlordReg.ConfirmBusinessDetails.s3',
                  'Company name'
                )}
              </h3>
              <p className="govuk-body govuk-!-font-size-19">
                {companyDataRedux && companyDataRedux.businessName}
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <h3 className="govuk-!-margin-top-0">
                {copyProvider.getCopy(
                  'landlordReg.ConfirmBusinessDetails.s4',
                  'Registered company address'
                )}
              </h3>
              {companyDataRedux && (
                <div className="govuk-body govuk-!-font-size-19 govuk-!-margin-bottom-5">
                  <section>
                    {companyDataRedux.businessAddressLine1 &&
                      `${companyDataRedux.businessAddressLine1},`}
                  </section>
                  <section>
                    {companyDataRedux.businessAddressLine2 &&
                      `${companyDataRedux.businessAddressLine2},`}
                  </section>
                  <section>
                    {companyDataRedux.businessAddressCity &&
                      `${companyDataRedux.businessAddressCity},`}
                  </section>
                  <section>
                    {companyDataRedux.businessAddressCounty &&
                      `${companyDataRedux.businessAddressCounty},`}
                  </section>
                  <section>
                    {companyDataRedux.businessAddressPostcode &&
                      companyDataRedux.businessAddressPostcode}
                    {companyDataRedux.businessAddressCountry && ','}
                  </section>
                  <section>
                    {companyDataRedux.businessAddressCountry &&
                      companyDataRedux.businessAddressCountry}
                  </section>
                </div>
              )}
            </td>
          </tr>
        </table>

        <div className="govuk-body govuk-!-font-size-19 govuk-!-margin-bottom-5">
          <section>
            {copyProvider.getCopy(
              'landlordReg.ConfirmBusinessDetails.s7',
              'Your company address may be different from the registered company address. If this is the case you may still proceed. We will not use this address to send any letters. Contact Companies House if you need to update your company address details.'
            )}
          </section>
        </div>
        <Link
          className="govuk-link govuk-body govuk-!-font-size-19"
          to="/landlordReg/company-registration-number"
        >
          {copyProvider.getCopy(
            'landlordReg.ConfirmBusinessDetails.s5',
            'This is not my business'
          )}
        </Link>
      </div>
      <Button className="govuk-button" onClick={handleBtnClick}>
        {copyProvider.getCopy(
          'landlordReg.ConfirmBusinessDetails.s6',
          'Confirm and continue'
        )}
      </Button>
    </>
  );
  return pageModel;
};

export default ConfirmBusinessDetails;
